export default __webpack_public_path__ + "static/media/step9-icon.0f225f2b.svg";